import { useRef } from 'react';

import { getPlainTextFromHtml } from '@shared/helpers';
import { useIsOverflowing } from '@shared/hooks';

export const useIsOverflowingContent = ({
    descriptionText,
    estimateText,
}: {
    descriptionText: string;
    estimateText: string;
}) => {
    const descriptionRef = useRef<HTMLDivElement>(null);
    const estimateRef = useRef<HTMLDivElement>(null);
    const { isOverflowing: isOverflowingDescription } = useIsOverflowing({ elRef: descriptionRef });
    const { isOverflowing: isOverflowingEstimate } = useIsOverflowing({ elRef: estimateRef });

    const titleAttrDescriptionText = isOverflowingDescription
        ? getPlainTextFromHtml(descriptionText)
        : '';
    const titleAttrEstimateText = isOverflowingEstimate ? estimateText : '';

    return { descriptionRef, estimateRef, titleAttrDescriptionText, titleAttrEstimateText };
};
